"use client";

import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { geoInfo, get } from '@/services/getip';

type GeoIPContextProps = {
    geoInfo: geoInfo;
    isLoading: boolean;
    refresh: () => void;
}

type Props = {
    children: ReactNode;
}

const GeoIPContext = createContext<GeoIPContextProps>({
    geoInfo: {} as geoInfo,
    isLoading: true,
    refresh: () => {
    },
});

export const useGeoIP = () => useContext(GeoIPContext);
export const GeoIPProvider = ({ children }: Props) => {
    const [info, setInfo] = useState({} as geoInfo);
    const [isLoading, setIsLoading] = useState(true);

    const refresh = () => {
        setIsLoading(true);
        get().then(({ status, data }) => {
            setInfo(status === 200 ? data : {} as geoInfo);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        refresh();
    }, []);

    return (
        <GeoIPContext.Provider value={{ geoInfo: info, isLoading, refresh }}>
            {children}
        </GeoIPContext.Provider>
    );
};